import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { MatchModal, StarPopover } from "../../components";
import moment from "moment";

// Library
import _ from "lodash";

// Material helpers
import { withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { List, ListItem } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import Button from "@material-ui/core/Button";
import SpellcheckIcon from "@material-ui/icons/Spellcheck";
import TablePagination from "@material-ui/core/TablePagination";

import Tooltip from "@material-ui/core/Tooltip";

// Style
import styles from "./styles";

class AllUtterances extends React.Component {
  state = {
    dialogOpened: false,
    modalValue: [],
    modalIndex: null,
    matchedQuestions: []
  };

  setUpData() {
    const newState = { ...this.state };
    var selected = [];
    var processed = [];
    var starRating = [];
    _.map(this.props.data, (utterance, key) => {
      selected[key] = utterance["Score"] > 0.5 ? "1" : "0";
      processed[key] = false;
      starRating[key] = 0;
    });
    newState.selected = selected;
    newState.processed = processed;
    newState.starRating = starRating;
    return newState;
  }

  //postavi row count u component state
  componentWillMount() {
    const newState = this.setUpData();
    newState.currentPage = this.props.currentPage;
    newState.rowCount = this.props.rowCount;
    newState.limit = this.props.limit;

    this.setState(newState);
  }

  mapToQuestionDialog = (e, index) => {
    e.preventDefault();
    const newState = { ...this.state };
    newState.dialogOpened = true;
    newState.modalValue = [this.props.data[index]["UserInput"]];
    newState.modalIndex = index;
    this.setState(newState);
  };

  closeMapToQuestionDialog = selectedQuestion => {
    const newState = { ...this.state };
    if (selectedQuestion) {
      let found = false;
      const utterance = this.props.data[newState.modalIndex];

      //this.props.data[newState.modalIndex].MatchedQuestion = selectedQuestion;
      // update existing value if exist

      _.forEach(newState.matchedQuestions, (value, index) => {
        if (value["Id"] == utterance["Id"] && value["Feedback"] != null) {
          value["MatchedQuestion"] = selectedQuestion;
          newState.processed[newState.modalIndex] = selectedQuestion;
          found = true;
        } else if (value["Id"] == utterance["Id"] && value["SimilarityScore"] != null) {
          value["MatchedQuestion"] = selectedQuestion;
        }
      });

      //add new answer for question
      if (!found) {
        newState.processed[newState.modalIndex] = selectedQuestion;
        newState.matchedQuestions.push({
          Id: utterance["Id"],
          UserInput: utterance["UserInput"],
          MatchedQuestion: selectedQuestion,
          Feedback: "1",
          SimilarityScore: null
        });
      }
    }

    newState.dialogOpened = false;
    newState.modalValue = [];
    newState.modalIndex = null;

    this.setState(newState);
  };

  onStarPopoverClose = (starsNum, index) => {
    if (!starsNum) return;
    const newState = { ...this.state };
    const utterance = this.props.data[index];
    let found = false;

    newState.starRating[index] = starsNum;

    let existingMatchedIndex = -1;
    let newMatchedAnswer = null;
    // update existing value if exist
    _.forEach(newState.matchedQuestions, (value, index) => {
      if (value["Id"] == utterance["Id"] && value["SimilarityScore"] != null) {
        value["SimilarityScore"] = starsNum;
        found = true;
        existingMatchedIndex = index;
      } else if (value["Id"] == utterance["Id"] && value["SimilarityScore"] == null) {
        newMatchedAnswer = value["MatchedQuestion"];
      }
    });
    // add new similarity to the array
    if (!found) {
      newState.matchedQuestions.push({
        Id: utterance["Id"],
        UserInput: utterance["UserInput"],
        MatchedQuestion: newMatchedAnswer ? newMatchedAnswer : utterance["MatchedQuestion"],
        SimilarityScore: starsNum,
        Feedback: null
      });
    } else {
      let tmo = newState.matchedQuestions[existingMatchedIndex];
    }

    this.setState(newState);
  };

  handleRadioChange = (event, index) => {
    const newState = { ...this.state };
    newState.selected[index] = event.target.value;
    this.setState(newState);
  };

  async saveUtteranceFeedback() {
    var { matchedQuestions, processed } = this.state;

    _.forEach(this.props.data, (utterance, index) => {
      matchedQuestions.push({
        Id: utterance["Id"],
        UserInput: utterance["UserInput"],
        MatchedQuestion: utterance["MatchedQuestion"], // processed[index] ? processed[index] : utterance["MatchedQuestion"],
        Feedback: this.state.selected[index],
        SimilarityScore: null
      });
    });
    await this.props.saveFeedback(matchedQuestions, true);
  }
  //promjena broja rowsa
  handleRowChange = e => {
    e.preventDefault();
    let limit = e.target.value;
    this.setState({ limit: limit });
    this.props.changeLimit(limit);
  };

  handlePaginationChange = (e, value) => {
    e.preventDefault();
    this.setState({ currentPage: value });
    this.props.loadMoreData(value * this.state.limit);
  };

  async waitForSaveAndLoadData() {
    await this.saveUtteranceFeedback();
    this.props.loadMoreData((this.state.currentPage - 1) * this.state.limit);
  }

  onSubmitAndLoad = e => {
    e.preventDefault();
    this.waitForSaveAndLoadData();
  };

  renderSingleUtterance(utterance, index) {
    const { classes } = this.props;
    const { selected, processed, starRating } = this.state;
    const value = selected[index];
    const stars = starRating[index];
    const hasNewAnswer = processed[index];
    const date = moment(utterance.Time).format("MMMM DD, YYYY @ hh:mm A");

    return (
      <React.Fragment>
        <ListItem key={index} className={classes.utteranceItem}>
          <div className={classes.utteranceItemDiv}>
            <p className={classes.utternaceDate}>Entry time: {date}</p>
            <p>Q: {utterance.UserInput}</p>
            {hasNewAnswer ? (
              <p>
                A: <strike>{utterance.OriginalQuestion}</strike>
              </p>
            ) : (
              <p>
                {" "}
                {!utterance.AboveThreshold ? (
                  <Tooltip placement="top" title="Not used on chatbot">
                    <span className={classes.aboveTreshold}>A: </span>
                  </Tooltip>
                ) : (
                  <span>A: </span>
                )}
                {utterance.OriginalQuestion}
              </p>
            )}
          </div>
          {hasNewAnswer ? (
            <React.Fragment>
              <div className={classes.utteranceSelectedAnswer}>
                <p className={classes.utteranceSelectedAnswerText}>A:{hasNewAnswer}</p>
                <IconButton onClick={e => this.mapToQuestionDialog(e, index)}>
                  <SpellcheckIcon className={classes.feedbackIcons} />
                </IconButton>
                <StarPopover index={index} stars={stars} onClose={this.onStarPopoverClose} />
              </div>
            </React.Fragment>
          ) : (
            <div>
              <Tooltip title="Mark if answer is correct" placement="top">
                <RadioGroup
                  row
                  aria-label="match"
                  name="match"
                  className={classes.formGroup}
                  value={value}
                  onChange={e => this.handleRadioChange(e, index)}
                >
                  <FormControlLabel value="0" control={<Radio />} />
                  <CloseIcon className={classes.utteranceIcons} />
                  <FormControlLabel value="1" control={<Radio />} />
                  <CheckIcon className={classes.utteranceIcons} />
                </RadioGroup>
              </Tooltip>
              <Tooltip title="Select Better Answer">
                <IconButton onClick={e => this.mapToQuestionDialog(e, index)} className={classes.questionButton}>
                  <SpellcheckIcon className={classes.feedbackIcons} />
                </IconButton>
              </Tooltip>
              <StarPopover index={index} stars={stars} onClose={this.onStarPopoverClose} />
            </div>
          )}
        </ListItem>
        <hr />
      </React.Fragment>
    );
  }

  renderUtteranceData() {
    const { data, classes, totalAudits } = this.props;
    const { currentPage, limit } = this.state;
    if (data === null) {
      var error = "";
      if (this.props.utterancesError == 404) {
        error = "No chabot for tenant name";
      } else if (this.props.utterancesError == 500) {
        error = "Internal error while loading data";
      }
      return (
        <Typography variant="h6">
          No results found for your specified criteria. Please change your search filter parameters. {error}
        </Typography>
      );
    }
    const totalPages = totalAudits > 0 ? _.ceil(totalAudits / limit) : 0;
    return (
      <React.Fragment>
        <Typography variant="h5">Total hits: {totalAudits}</Typography>
        <div className={classes.pagination}>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50, 75]}
            rowsPerPage={limit}
            component="div"
            count={totalAudits}
            page={currentPage - 1}
            onChangePage={this.handlePaginationChange}
            onChangeRowsPerPage={this.handleRowChange}
            labelRowsPerPage={""}
            classes={{
              input: classes.customSelect,
              toolbar: classes.paginationToolbar,
              actions: classes.arrows
            }}
          />
        </div>
        <br />
        <hr />
        {_.map(data, (utterance, index) => (
          <React.Fragment key={index}>{this.renderSingleUtterance(utterance, index)}</React.Fragment>
        ))}
        <div className={classes.loadButtons}>
          <div className={classes.loadMore}>
            <Button variant="contained" color="primary" className={classes.button} onClick={this.onSubmitAndLoad}>
              Train
            </Button>
          </div>
        </div>
        <div className={classes.pagination}>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50, 75]}
            rowsPerPage={limit}
            component="div"
            count={totalAudits}
            page={currentPage - 1}
            onChangePage={this.handlePaginationChange}
            onChangeRowsPerPage={this.handleRowChange}
            labelRowsPerPage={""}
            classes={{
              input: classes.customSelect,
              toolbar: classes.paginationToolbar,
              actions: classes.arrows
            }}
          />
        </div>
      </React.Fragment>
    );
  }

  render() {
    const { classes } = this.props;
    const { modalValue, dialogOpened } = this.state;

    return (
      <React.Fragment>
        <List dense={true} className={classes.list}>
          {this.renderUtteranceData()}
        </List>
        {dialogOpened && (
          <MatchModal
            data={modalValue}
            open={dialogOpened}
            cluster={false}
            parentCloseFunc={this.closeMapToQuestionDialog}
          />
        )}
      </React.Fragment>
    );
  }
}

AllUtterances.propTypes = {};

function mapStateToProps(state) {
  return {
    utterancesError: state.utterance["code"],
    totalAudits: !_.isEmpty(state.utterance) ? state.utterance.total : 0
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({}, dispatch),
    dispatch
  };
}

AllUtterances = connect(
  mapStateToProps,
  mapDispatchToProps
)(AllUtterances);

export default withStyles(styles)(AllUtterances);
